import React from "react";

const CancelPage = () => {
    return (
        <div>
            <h1>Payment Canceled</h1>
            <p>Your payment was not completed. Please try again.</p>
        </div>
    );
};

export default CancelPage;
